import { LabelType } from '../../../../store';
import { labelText } from '../../../../utils/labelText';
import { LabelNameEditor } from './LabelNameEditor';

interface EditLabelDetailsSectionProps {
  marker: LabelType;
  notPlacedLabels: LabelType[];
  selectedId: string;
  onSelectedIdChange: (value: string) => void;
  name: string;
  onNameChange: (value: string) => void;
}

export function EditLabelDetailsSection({
  marker,
  notPlacedLabels,
  selectedId,
  name,
  onSelectedIdChange,
  onNameChange,
}: EditLabelDetailsSectionProps) {
  if (!marker) return null;
  return (
    <section className="theme-sidebar__section">
      <h4>Label</h4>
      {notPlacedLabels.length > 0 && (
        <label className="theme-select">
          <span className="theme-select__label">Action</span>
          <select
            id="label-id"
            value={selectedId}
            onChange={(e) => onSelectedIdChange(e.target.value)}
            className="theme-select__control"
          >
            {(marker.id === 'newLabel') && (
              <option value="newLabel">Create new label</option>
            )}
            <optgroup label="Use existing">
              {marker.id !== 'newLabel' && (
                <option value={marker.id}>{labelText(marker.name)}</option>
              )}
              {notPlacedLabels.sort((a,b) => labelText(a.name).localeCompare(labelText(b.name))).map((label) => (
                <option value={label.id} key={label.id}>
                  {labelText(label.name)}
                </option>
              ))}
            </optgroup>
          </select>
        </label>
      )}
      {selectedId === marker.id && (
        <div className="theme-select">
          <span className="theme-select__label">Name</span>
          <LabelNameEditor
            aria-label="Name"
            data-label-editor-primary-focus="true"
            value={name}
            onChange={onNameChange}
          />
        </div>
      )}
    </section>
  );
}

export default EditLabelDetailsSection;
